import React from 'react';
import noop from 'lodash-es/noop';

import { colors } from '../fj-styles';
import * as Components from './components';

interface FjCheckboxTypeComponents {
  // Components is an untyped .js module, so styled components resolve as any.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Fascade: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Indicator: any;
}

const fjCheckboxTypes = (type: string, mini?: boolean): FjCheckboxTypeComponents =>
  type === 'radio'
    ? {
        Fascade: Components.RadioFascade,
        Indicator: Components.RadioIndicator,
      }
    : {
        Fascade: mini ? Components.MiniCheckboxFascade : Components.CheckboxFascade,
        Indicator: Components.CheckIndicator,
      };

interface FjCheckboxProps {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  color?: string;
  bgColor?: string;
  disabled?: boolean;
  type?: string;
  label?: React.ReactNode;
  name?: string;
  id?: string;
  outlineOnFocus?: boolean;
  dataTestId?: string;
  className?: string;
  mini?: boolean;
  labelColor?: string;
}

const FjCheckbox = ({
  checked = false,
  onChange = noop,
  color = colors.teal.hex(),
  bgColor = 'transparent',
  disabled = false,
  type = 'checkbox',
  label = '',
  name = undefined,
  id = undefined,
  outlineOnFocus = false,
  dataTestId = undefined,
  ...otherProps
}: FjCheckboxProps) => {
  const props = {
    checked,
    onChange,
    color,
    bgColor,
    disabled,
    type,
    label,
    name,
    id,
    outlineOnFocus,
    dataTestId,
    ...otherProps,
  };
  const { Fascade, Indicator } = fjCheckboxTypes(props.type, props.mini);

  const handleClick = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.target.checked = !props.checked;
    props.onChange(e);
  };

  return (
    <Components.Wrapper
      color={props.color}
      bgColor={props.bgColor}
      className={props.className}
      disabled={props.disabled}
    >
      <Components.Label htmlFor={props.id}>
        <Components.Input
          id={props.id}
          type={props.type}
          role={props.type}
          checked={props.checked}
          name={props.name}
          disabled={props.disabled}
          onChange={handleClick}
        />
        <Fascade
          disabled={props.disabled}
          outlineOnFocus={props.outlineOnFocus}
          data-testid={props.dataTestId}
        >
          <Indicator checked={props.checked} />
        </Fascade>
        {props.label && (
          <Components.LabelText labelColor={props.labelColor}>{props.label}</Components.LabelText>
        )}
      </Components.Label>
    </Components.Wrapper>
  );
};

export default FjCheckbox;
